const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user likes component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {MainComments} MainComments the resource defined to manage MainComments
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 */
app.directive('mainComments', ['Application', 'Authorization', 'MainComments', 'Analyze', '$filter', function (Application, Authorization, MainComments, Analyze, $filter) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentType: '=',
      contentId: '=',
      subType: '=',
      subId: '=',
      trackLocation: '@',
      contentDirectory: '='
    },
    template: require('../../templates/directives/main-comments.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.user = Authorization.getAuthToken().user;
      var currentUser = Authorization.getAuthToken().user._id;
      var initialized = false;
      self.findType = function (url, secondary) {
        // tracks must be first as it may contain other types in the url
        if (!secondary && /tracks/g.test(url)) {
          return 'track';
        }

        if (/articles/g.test(url)) {
          return 'article';
        }
        if (/videos/g.test(url)) {
          return 'video';
        }
        if (/files/g.test(url)) {
          return 'file';
        }
        if (/events/g.test(url)) {
          return 'event';
        }
        if (/quizzes/g.test(url)) {
          return 'quiz';
        }
        if (/workshops/g.test(url)) {
          return 'workshop';
        }
        if (/imported-content/g.test(url)) {
          return 'imported_content';
        }
        if (/assessments/g.test(url)) {
          return 'assessment';
        }
        if (/scorm/g.test(url)) {
          return 'scorm';
        }
        return null;
      };

      self.comment = ''
      self.mentions = [];
      self.submission = false;
      self.showSubmit = false;
      self.submit = function() {
        self.submission = true;
        // timeout is needed to allow the digest cycle
        setTimeout(function() {
          self.postComment();
        }, 10)
      };

      self.postComment = function() {
        self.postLoading = true;
        self.testSubmit = true;

        var item = {
          user: currentUser,
          comment: self.comment,
          mentions: self.mentions,
          is_reply: false,
          children: [],
          removed: false,
          likes: []
        };

        item[self.contentType] = self.contentId;

        // Maintain inner context of content in a track
        if (self.contentType === 'track') {
          // This will maintain the secondary type for track context
          var secondaryType = self.findType(Application.navigation.getUrl(), true);

          if (secondaryType && routeParameters.id) {
            if (secondaryType === 'video' || secondaryType === 'file') {
              item.media = routeParameters.id;
            } else {
              item[secondaryType] = routeParameters.id;
            }
          }
        }

        MainComments.create({
          fields: 'comment,media,track,article,evnt,workshop,imported_content,scorm,user,quiz,assessment,edited,createdAt',
          type: self.contentType,
          contentId: self.contentId
        }, item, function(data) {
          data.user = Authorization.getAuthToken().user;
          self.information.comments.push(data);
          self.postLoading = false;
          var type = self.findType(Application.navigation.getUrl());
          if (type) {
            Analyze.record({resource: 'comments'}, {content: self.contentId, content_type: type});
            Application.analyticsProvider.trackEvent(type + '_commented', {content: self.contentId, content_type: type, title: self.title});
          }
          if (self.information.single) {
            self.information.exitSingle();
          }
        }, function(err) {
          console.log('Error occured creating comment ', err);
          self.postLoading = false;
        });
      };

      self.snipTitle = function(title) {
        return $filter('commentTitleSnip')(title)
      };

      self.information = {
        page: 1,
        per_page: 5,
        single: false,
        showReply: false,
        comments: [],
        options: {},
        moreAvailable: false,
        hideComment: false,
        loading: false,
        count: 0,
        get: function() {
          this.options.page = this.page;
          this.options.per_page = this.per_page;
          this.loading = true;

          MainComments.find(this.options, function (data) {
            self.information.moreAvailable = false;
            if (data && data.length && data.length === self.information.per_page) {
              self.information.moreAvailable = true;
            }
            data.forEach(function(comment) {
              self.information.comments.push(comment);
            });
            self.information.loading = false;
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting suggestions ', error);
            self.information.loading = false;
            self.loading = false;
          });
        },
        getSingle: function(id) {
          MainComments.get({subresource: id, fields: this.options.fields, 'user-populate': this.options['user-populate']}).$promise
          .then(function(comment) {
            self.information.comments = [comment];
            self.loading = false;
            // allow all elements to show before scrolling to bottom
            setTimeout(function() {
              window.scrollTo(0,document.body.scrollHeight);
            }, 50);
          }).catch(function(error) {
            console.log('error getting single comment.')
            self.information.single = false;
            self.loading = false;
          });

          // Get count to know when to display
          var countOptions = JSON.parse(JSON.stringify(this.options));
          MainComments.count(countOptions, function (data) {
            if (data && data.count) {
              self.information.count = data.count;
            }
          }, function (error) {
          });
        },
        exitSingle: function() {
          this.single = false;
          this.comments = [];
          this.page = 1;
          this.get();
        },
        viewMore: function() {
          this.page++;
          this.get();
        }
      };

      self.looseTrack = {
        page: 1,
        per_page: 5,
        active: false,
        showReply: false,
        comments: [],
        options: {},
        moreAvailable: false,
        get: function() {
          this.options.page = this.page;
          this.options.per_page = this.per_page;

          MainComments.find(this.options, function (data) {
            self.looseTrack.moreAvailable = false;
            if (data && data.length && data.length === self.looseTrack.per_page) {
              self.looseTrack.moreAvailable = true;
            }
            data.forEach(function(comment) {
              self.looseTrack.comments.push(comment);
            });
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting suggestions ', error);
            self.loading = false;
          });
        },
        viewMore: function() {
          this.page++;
          this.get();
        }
      };

      self.initialize = function () {
        delete self.information.options.track;
        delete self.information.options.media;
        delete self.information.options.article;
        delete self.information.options.workshop;
        delete self.information.options.imported_content;
        delete self.information.options.quiz;
        delete self.information.options.assessment;
        delete self.information.options.scorm;
        delete self.looseTrack.options.track;
        delete self.looseTrack.options.media;
        delete self.looseTrack.options.article;
        delete self.looseTrack.options.workshop;
        delete self.looseTrack.options.imported_content;
        delete self.looseTrack.options.quiz;
        delete self.looseTrack.options.assessment;
        delete self.looseTrack.options.scorm;
        self.information.comments = [];
        self.looseTrack.comments = [];

        self.contentId = $scope.contentId;
        self.contentType = $scope.contentType === 'file' ? 'media' : $scope.contentType === 'video' ? 'media' : $scope.contentType;
        if ($scope.subId) {
          self.subId = $scope.subId;
          self.subType = $scope.subType === 'file' ? 'media' : $scope.subType === 'video' ? 'media' : $scope.subType;
        }

        self.loading = true;
        self.information.options[self.contentType] = self.contentId;
        self.information.options.is_reply = '$ne,true';
        self.information.options.fields = 'comment,media,track,article,evnt,workshop,imported_content,quiz,assessment,scorm,user,edited,createdAt,mentions,likes,removed,is_reply,children';
        self.information.options['user-populate'] = 'first_name,last_name,email,image,job_title';
        self.information.options.sort = "createdAt,-1";

        // Create 2 separate options - one with the track and sub content and one with the track and all other subcontent
        if (self.contentType === 'track' && self.subId && self.subType) {
          self.looseTrack.options = JSON.parse(JSON.stringify(self.information.options));
          self.information.options[self.subType] = self.subId;
          self.looseTrack.options[self.subType] = '$ne,' + self.subId;
          self.looseTrack.active = true;
        }

        // This keeps track comments separate from comments on individual content.
        if (self.contentType !== 'track') {
          self.information.options.track = '$exists,false';
        }

        if (routeParameters.comment) {
          if (routeParameters.reply) {
            self.information.showReply = routeParameters.reply;
          }
          self.information.single = true;
          self.information.getSingle(routeParameters.comment);
          return;
        }
        self.information.get();
        if (self.contentType === 'track' && self.subId && self.subType) {
          self.looseTrack.get();
        }
      };

      if ($scope.trackLocation === 'inner') {
        $scope.$watch('subId', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          self.initialize();
        });
      }

      $scope.$watch('contentId', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.initialize();
      });

      if ($scope.contentId && $scope.contentType) {
        self.initialize();
      }
    }],
    controllerAs: 'comments'
  };
}]);
